module.exports = __webpack_public_path__ + "img/bear7.8cc8245b.svg";